export const AVAILABLE_PROPERTIES = 'AVAILABLE_PROPERTIES';
export const GET_AVAILABLE_FILTERED_PROPERTIES = 'GET_AVAILABLE_FILTERED_PROPERTIES';
export const GET_PANEL_FILTERED_PROPERTIES = 'GET_PANEL_FILTERED_PROPERTIES';
export const GET_ADMIN_DATA = 'GET_ADMIN_DATA';
export const GET_USER_DATA = 'GET_USER_DATA';
export const GET_SEARCHED_POST = 'GET_SEARCHED_POST';
export const ORDER_BY = 'ORDER_BY';
export const GET_USER = 'GET_USER';
export const ADD_USER = 'ADD_USER';
export const EDIT_USER = 'EDIT_USER';
export const DELETE_USER = 'DELETE_USER';
export const GET_POST = 'GET_POST';
export const ADD_POST = 'ADD_POST';
export const EDIT_POST = 'EDIT_POST';
export const DELETE_POST = 'DELETE_POST';
export const GET_BOOKING = 'GET_BOOKING';
export const ADD_BOOKING = 'ADD_BOOKING';
export const EDIT_BOOKING = 'EDIT_BOOKING';
export const DELETE_BOOKING = 'DELETE_BOOKING';
export const GET_ADMIN_USERS_DATA = 'GET_ADMIN_USERS_DATA';
export const CHANGE_URL = 'CHANGE_URL';
export const USER_SESSION = 'USER_SESSION';
// export const GET_ALL_POST_PANEL_NEXT = 'get_all_post_panel_next';
